

























































import { Component, Vue, Watch } from "vue-property-decorator";
import jwt from "jsonwebtoken";

@Component({
  components: {},
})
export default class HomeLayout extends Vue {
  userInfo: any = {};

  selectedKeys: any[] = [0];

  collapsed = false;

  title = "";

  menus: any[] = [
    // {
    //   key: "schedule",
    //   title: "일정",
    //   icon: "schedule",
    //   children: ["root"],
    // },
    {
      key: "member",
      title: "회원정보",
      icon: "user",
      children: ["memberDetail", "memberHistory"],
    },
    // {
    //   key: "magazine",
    //   title: "매거진 관리",
    //   icon: "form",
    // },
    // {
    //   key: "history",
    //   title: "송금 이력 조회",
    //   icon: "bulb",
    // },
    {
      key: "confirm",
      title: "유전자 검사 신청 관리",
      icon: "warning",
    },
    {
      key: "banner",
      title: "메인 배너관리",
      icon: "notification",
    },
    {
      key: "healthBanner",
      title: "건강정보 배너관리",
      icon: "bulb",
    },
    {
      key:"appPush",
      title:"앱 푸시",
      icon: "message",
    }
    // {
    //   key: "version",
    //   title: "앱 버전관리",
    //   icon: "setting",
    // },
    // {
    //   key: "wallet",
    //   title: "지갑 현황",
    //   icon: "wallet",
    // },
    // {
    //   key: "android",
    //   title: "안드로이드 콘솔",
    //   icon: "android",
    //   type: "link",
    //   link: "https://play.google.com/console/u/0/developers/5669846425278575496/app/4976252050385655158/app-dashboard?timespan=thirtyDays",
    // },
    // {
    //   key: "apple",
    //   title: "IOS 콘솔",
    //   icon: "apple",
    //   type: "link",
    //   link: "https://appstoreconnect.apple.com/apps",
    // },
  ];

  @Watch("$route", { deep: true })
  async routeChange() {
    const routeName = this.$route.name;
    console.log(routeName);
    const index = this.menus.findIndex(
      (item) =>
        item.key === routeName ||
        (item.children && item.children.indexOf(routeName) !== -1)
    );
    console.log(index);

    if (index !== -1) {
      this.title = this.menus[index].title;
      this.selectedKeys = [index];
      return;
    }

    this.title = "";
    this.selectedKeys = [0];
  }

  mounted() {
    this.routeChange();

    const token = localStorage.getItem("token");
    if (token) {
      this.userInfo = jwt.decode(token);
    }
  }

  async logout() {
    localStorage.setItem("token", "");
    location.href = "/";
  }
}
